<div class="overlay">
    <div class="toolbar">
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <iframe *ngIf="pdfUrl" [src]="pdfUrl" class="pdf-frame"></iframe>
  </div>